// @flow
import FutureJob from '../protocol/FutureJob';
import {
  WebclientAddFolderQuery,
  WebclientAddFolderMessage,
  WebclientAddFolderResponse
} from '../autogenerated/ZoomBridge';

const debug = require('../debug/debug')('wc:upload:CreateFolderJob');

/**
 * A {@link FutureJob} that creates a new folder.
 */
export default class CreateFolderJob extends FutureJob {
  _name: string;
  _projectName: string;
  _uploadPath: string;

  constructor(name: string, projectName: string, uploadPath: string) {
    super();

    this._name = name;
    this._projectName = projectName;
    this._uploadPath = uploadPath;
  }

  get name() {
    return this._name;
  }

  async start() {
    try {
      if (this._done || this._canceled) {
        return;
      }

      this._started = true;

      const query = new WebclientAddFolderQuery();
      const msg = new WebclientAddFolderMessage()
        .setProject(this._projectName)
        .setDestPath(this._uploadPath)
        .setPath(this._name);

      query.message = msg;
      debug('[start()] query: ', query);
      const res: WebclientAddFolderResponse = await query.run();
      debug('[start()] res: ', res);
      this.emit('resolve', this, res);
    } catch (err) {
      debug('[start()] error: ', err);
      this.emit('reject', this);
    }
  }

  cancel() {
    if (!this._done) {
      this._canceled = true;
    }
  }
}
